import React from 'react'

const screen = {
    position: "fixed",
    background: "linear-gradient(90deg, #ed752f, #da5f7e 47.92%, #2f77f4)",
    height: "100vh",
    width: "120vw",
    transition: "transform 0.5s ease, all 1.0s ease",
    left: "-10vw",
    zIndex: "100000"
}

function ColorBG({ style }) {

    return (
        <div id="overlay" style={{ ...screen, ...style }}>
            <h1 className='position-absolute top-50 start-50 translate-middle-y fw-bold' style={{ translate: "-75%" }}>GLYPH</h1>
        </div >
    )
}

export default ColorBG;
